import { render, staticRenderFns } from "./trafficProductInquiry.vue?vue&type=template&id=04e6fde0"
import script from "./trafficProductInquiry.vue?vue&type=script&lang=js"
export * from "./trafficProductInquiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04e6fde0')) {
      api.createRecord('04e6fde0', component.options)
    } else {
      api.reload('04e6fde0', component.options)
    }
    module.hot.accept("./trafficProductInquiry.vue?vue&type=template&id=04e6fde0", function () {
      api.rerender('04e6fde0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inquiry/child/trafficProductInquiry.vue"
export default component.exports